import './App.css';
import { BrowserRouter as Router, Routes, Route,} from "react-router-dom";
import Header from './component/Header';
import Homepage from './pages/Homepage';
import Coins from './pages/Coins';
import { makeStyles } from '@material-ui/core/styles';
const useStyles= makeStyles({
  App: {
    backgroundColor:'black',
    color:'white'
  },
});

function App() {
 const classes = useStyles();

  return (

    <>
       <Router>
       <div className={classes.App} >
        <Header/>
        <Routes>
         <Route exact path='/' element={<Homepage/>} ></Route>
         <Route exact path='/Coins/:id' element={<Coins/>} ></Route>
        
       </Routes>
       </div>
       </Router>

       </>
    
  );
}

export default App;
